<div id="sidebar-wrapper">
  <div id="sidebar-header" [class.compact]="isSubMenuOpen()">
    <div class="w-100 d-flex align-items-center gap-4">
      <!-- Close sidebar button (only visible on desktop when sidebar is OPEN) -->
      @if (!isSubMenuOpen()) {
        <button mat-icon-button (click)="closeSidebar.emit()" class="toggle-sidebar-btn shrink-0" matTooltip="{{ 'Global.Close' | translate }}">
          <mat-icon>left_panel_close</mat-icon>
        </button>
        <div class="home-logo flex-grow-1 min-w-0 d-flex align-items-center" style="height: 36px; max-width: 165px">
          <a [routerLink]="['/home']" class="d-inline-flex align-items-center w-100 h-100">
            <img
              [src]="tenantBrandingService.logoUrl() || 'assets/creatives/logo-w70.png'"
              (error)="onLogoError($event)"
              id="img-logo"
              [alt]="tenantBrandingService.appName() + ' logo'"
              class="w-100 h-100"
              style="object-fit: contain; object-position: left center"
            />
          </a>
        </div>
      }
    </div>

    @if (!isSubMenuOpen()) {
      <app-language-selector></app-language-selector>
      <app-float-edit-menu [host]="'sidebar-nav'"></app-float-edit-menu>
    }
  </div>

  <div class="menu-container">
    <div [class.menu-content]="!isNoteMenuOpen() && !isKnowledgeMenuOpen()" [class.menu-content-note]="isNoteMenuOpen()" [class.menu-content-knowledge]="isKnowledgeMenuOpen()">
      @if (isArticleMenuOpen()) {
        <div id="knowledge-navigation-menu" @menuSwitch>
          <mat-nav-list>
            <mat-list-item (click)="navigateBackToMainMenu()" class="back-button">
              <mat-icon matListItemIcon>arrow_back</mat-icon>
              <span matListItemTitle>{{ 'Home.Header.Back' | translate }}</span>
            </mat-list-item>
            <mat-list-item class="article-menu-header" disabled>
              <mat-icon matListItemIcon>article</mat-icon>
              <span matListItemTitle>
                <strong>{{ 'Home.Header.BlogButton' | translate }}</strong>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </div>
      } @else if (isNoteMenuOpen()) {
        <div id="notes-list" class="mt-2" @menuSwitch>
          <app-notes-list />
        </div>
      } @else if (isKnowledgeMenuOpen()) {
        <div id="knowledge-navigation-menu" class="knowledge-menu" @menuSwitch>
          <div class="sub-menu-toolbar my-2">
            <button mat-icon-button class="sub-menu-toolbar__back" (click)="navigateBackToMainMenu()" [matTooltip]="'Home.Header.Back' | translate">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <span class="sub-menu-toolbar__title" [matTooltip]="knowledgeName" matTooltipShowDelay="700">
              {{ knowledgeName || ('Home.Header.CourseButton' | translate) }}
            </span>
          </div>
          @if (hasWriteAccess()) {
            <div class="border-t border-[#eee] pt-2 mb-2 flex justify-center">
              <app-split-button
                [mainItem]="mainSplitButtonAction"
                [menuItems]="splitButtonMenuItems"
                [buttonId]="'addLectureOrSection'"
                (mainActionClick)="onSplitMenuItemClick($event)"
                (menuItemClick)="onSplitMenuItemClick($event)"
              ></app-split-button>
            </div>
          }
          <div class="knowledge-tree-container">
            <app-knowledge-navigator [path]="pathname()" (knowledgeName)="onKnowledgeName($event)" />
          </div>
        </div>
      } @else {
        <div id="navigation-menu" class="w-100" @menuSwitch>
          <!-- Quick Search Button -->
          <!-- <div class="px-3 pb-2 pt-1">
            <button mat-stroked-button class="w-100 d-flex justify-content-between align-items-center rounded-lg border-[#e0e0e0] text-[#5f6368]" (click)="openQuickSearch($event)">
              <div class="d-flex align-items-center">
                <mat-icon class="mr-2 text-[18px] w-[18px] h-[18px]">search</mat-icon>
                <span class="text-[13px] font-medium">Recherche rapide</span>
              </div>
              <span class="text-[11px] bg-[#f1f3f4] px-1.5 py-0.5 rounded">Cmd K</span>
            </button>
          </div> -->

          <mat-nav-list>
            @for (item of mainMenuItems; track item) {
              <mat-list-item
                [routerLink]="item.link ? [item.link] : null"
                (click)="item.action ? performAction(item.action) : null"
                [attr.role]="item.link ? 'link' : item.action ? 'button' : null"
                [class.selected]="item.link && pathname()?.startsWith(item.link)"
                [style.cursor]="item.action || item.link ? 'pointer' : 'default'"
              >
                @if (item.isSvgIcon) {
                  <mat-icon [svgIcon]="item.isSvgIcon ? item.icon : null" matListItemIcon>{{ !item.isSvgIcon ? item.icon : '' }}</mat-icon>
                }
                @if (!item.isSvgIcon) {
                  <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                }
                <span matListItemTitle>{{ item.view | translate }}</span>
              </mat-list-item>
            }

            @if (mySpaceMenuItems.length > 0) {
              @for (item of mySpaceMenuItems; track item) {
                <mat-list-item
                  [routerLink]="item.link ? [item.link] : null"
                  (click)="item.action ? performAction(item.action) : null"
                  [attr.role]="item.link ? 'link' : item.action ? 'button' : null"
                  [class.selected]="item.link && pathname()?.startsWith(item.link)"
                  [style.cursor]="item.action || item.link ? 'pointer' : 'default'"
                >
                  @if (item.isSvgIcon) {
                    <mat-icon [svgIcon]="item.isSvgIcon ? item.icon : null" matListItemIcon>{{ !item.isSvgIcon ? item.icon : '' }}</mat-icon>
                  }
                  @if (!item.isSvgIcon) {
                    <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                  }
                  <span matListItemTitle>{{ item.view | translate }}</span>
                </mat-list-item>
              }
            }
            <!-- Tutorials button -->
            <!-- <mat-list-item
              id="tutorials-btn"
              [routerLink]="['/tutorials']"
              [class.selected]="pathname()?.startsWith('/tutorials')"
              [style.cursor]="'pointer'"
            >
              <mat-icon matListItemIcon>play_lesson</mat-icon>
              <span matListItemTitle>{{ 'Tutorials.Title' | translate }}</span>
            </mat-list-item> -->
          </mat-nav-list>
        </div>
      }
    </div>
  </div>

  <div id="sidebar-footer">
    @if (currentUser(); as user) {
      <app-mini-credit-counter />
      @if (!isSubMenuOpen() && user.tenants?.length > 1) {
        <div class="workspace-selector">
          <ui-select class="w-100" [options]="tenantOptions()" [ngModel]="tenantService.activeTenantId()" [compact]="true" (valueChange)="switchWorkspace($event)"></ui-select>
        </div>
      }
      @if (isSubMenuOpen() && !isNoteMenuOpen()) {
        <app-language-selector></app-language-selector>
      }
      <div class="user-profile-section" (click)="openUserMenu($event)">
        <ui-user [name]="user.fullName" [imageUrl]="user.photo || user.picture" [description]="user.email" size="sm"></ui-user>
      </div>
    } @else {
      <mat-nav-list>
        <mat-list-item class="logout-btn" (click)="performAction('logout')">
          <mat-icon matListItemIcon>logout</mat-icon>
          <span matListItemTitle>{{ 'Home.Header.logOut' | translate }}</span>
        </mat-list-item>
      </mat-nav-list>
    }
  </div>
</div>
